import {
  useTrackFeature,
  useTrackOnCloseFilter,
  useTrackOnOpenFilter,
} from '@aboutyou/tracking';
import {FilterFlyoutIconName, Icon} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {FilterSectionSorting} from '../../../features/Filters/InlineFilter/FilterSections/FilterSectionSorting';
import {SortFlyout} from '../../../features/Filters/SortFlyout/SortFlyout';
import {useSortFlyoutOpenedState} from '../../../features/Filters/SortFlyout/hooks/useSortFlyoutOpenedState';
import {useWishlistSortingOptions} from '../hooks/useWishlistSortingOptions';

interface WishlistSortingButtonProps {
  variant: 'flyout' | 'dropdown';
}

const DEFAULT_SORT = 'recently_added';

export const WishlistSortingButton = (props: WishlistSortingButtonProps) => {
  const sortingOptions = useWishlistSortingOptions();
  const {open} = useSortFlyoutOpenedState();

  const trackOnCloseFilter = useTrackOnCloseFilter();
  const trackOnOpenFilter = useTrackOnOpenFilter();
  const trackOnCloseSort = () => trackOnCloseFilter('sort', 'filter_modal');
  const trackOnOpenSort = () => trackOnOpenFilter('sort', 'filter_modal');

  const trackFeature = useTrackFeature();

  const {variant} = props;

  const trackOpen = () => {
    trackOnOpenSort();
    trackFeature({
      eventType: 'click',
      label: 'wl_sort',
    });
  };

  const trackClose = () => {
    trackOnCloseSort();
    trackFeature({
      eventType: 'close',
      label: 'wl_sort',
    });
  };

  const trackSort = () => {
    trackFeature({
      eventType: 'submit',
      label: 'wl_sort',
    });
  };

  if (variant === 'flyout') {
    return (
      <>
        <StyledIcon
          onClick={() => {
            trackOpen();
            open();
          }}
          asset={FilterFlyoutIconName.SortAlt}
          size="M"
          data-testid="WishlistSortingFlyoutOpener"
        />
        <SortFlyout
          sortingOptions={sortingOptions}
          renderInPortal
          defaultSortingOptionId={DEFAULT_SORT}
          onClose={trackClose}
          onSort={trackSort}
          shouldTrackImmediately
        />
      </>
    );
  }
  return (
    <FilterSectionSorting
      defaultSortingOptionId={DEFAULT_SORT}
      sortingOptions={sortingOptions}
      onOpen={trackOpen}
      onClose={trackClose}
      onSort={trackSort}
    />
  );
};

const StyledIcon = styled(Icon)`
  padding: 5px;
`;
